import React, { useState } from "react";
import { MdEdit, MdDelete } from "react-icons/md";
import toast from "react-hot-toast";
import Input from "../../../../components/input";
import { ARTICLE_FIELD_LIMITS } from "../../../../utils/contentTypes";
import "./tagInput.css";

const TagInput = ({ tags = [], onChange, errors, touched }) => {
  const [value, setValue] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);

  const safeTags = Array.isArray(tags) ? tags : [];

  const resetEditor = () => {
    setValue("");
    setEditingIndex(null);
  };

  const saveTag = () => {
    const tag = value.trim();

    if (!tag) return;

    if (tag.length > ARTICLE_FIELD_LIMITS.TAG_MAX_LENGTH) {
      toast.error(
        `Each tag must be at most ${ARTICLE_FIELD_LIMITS.TAG_MAX_LENGTH} characters`,
      );
      return;
    }

    if (
      editingIndex === null &&
      safeTags.length >= ARTICLE_FIELD_LIMITS.TAGS_MAX_COUNT
    ) {
      toast.error(
        `Maximum ${ARTICLE_FIELD_LIMITS.TAGS_MAX_COUNT} tags allowed`,
      );
      return;
    }

    const duplicate = safeTags.some(
      (t, i) =>
        t.trim().toLowerCase() === tag.toLowerCase() && i !== editingIndex,
    );

    if (duplicate) {
      toast.error("Tag already exists");
      return;
    }

    let updated;

    if (editingIndex !== null) {
      updated = safeTags.map((t, i) => (i === editingIndex ? tag : t));
    } else {
      updated = [...safeTags, tag];
    }

    onChange(updated);
    resetEditor();

    console.log("[TagInput] Tag added:", tag, updated);
  };

  const handleAddClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    saveTag();
  };

  const deleteTag = (index) => {
    const updated = safeTags.filter((_, i) => i !== index);

    // If deleting currently editing tag
    if (editingIndex === index) {
      resetEditor();
    }

    // Shift editing index
    else if (editingIndex !== null && editingIndex > index) {
      setEditingIndex(editingIndex - 1);
    }

    onChange(updated);
  };

  const editTag = (index) => {
    setEditingIndex(index);
    setValue(safeTags[index]);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      saveTag();
    }

    if (e.key === "Escape") {
      resetEditor();
    }
  };

  return (
    <div className="tag-wrapper">
      <div className="tag-input-row">
        <div style={{ flex: 1 }}>
          <Input
            label="Tags"
            name="tagInput"
            placeholder="Type a tag..."
            value={value}
            handleChange={(e) => setValue(e.target.value)}
            handleOnBlur={() => {}}
            handleKeyDown={handleKeyDown}
            maxLength={ARTICLE_FIELD_LIMITS.TAG_MAX_LENGTH}
          />
        </div>

        <button
          type="button"
          className="tag-add-btn"
          onMouseDown={(event) => event.preventDefault()}
          onClick={handleAddClick}
          disabled={!value.trim()}
        >
          {editingIndex !== null ? "Save" : "Add"}
        </button>

        {editingIndex !== null && (
          <button
            type="button"
            className="tag-cancel-btn"
            onClick={resetEditor}
          >
            Cancel
          </button>
        )}
      </div>

      {touched?.tags && errors?.tags ? (
        <p className="input-error-text">
          {Array.isArray(errors.tags) ? errors.tags.find(Boolean) : errors.tags}
        </p>
      ) : null}

      {!!safeTags.length && (
        <div className="tag-list">
          {safeTags.map((tag, index) => (
            <div className="tag-chip" key={`${tag}-${index}`}>
              <span>{tag.trim()}</span>

              <button type="button" title="Edit" onClick={() => editTag(index)}>
                <MdEdit />
              </button>

              <button
                type="button"
                title="Delete"
                onClick={() => deleteTag(index)}
              >
                <MdDelete />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TagInput;
